import { ShoppingCart } from "lucide-react";
import { motion, useAnimationControls } from "motion/react";
import { useEffect } from "react";
import { useCart } from "../../context/CartContext";

/** Ícone do carrinho na navbar: pulsa e o contador "pula" a cada item adicionado. */
export const CartButton = () => {
  const { count, bump, openCart } = useCart();
  const controls = useAnimationControls();

  useEffect(() => {
    if (bump === 0) return;
    controls.start({
      scale: [1, 1.3, 0.9, 1],
      rotate: [0, -14, 10, 0],
      transition: { duration: 0.55, ease: "easeOut" },
    });
  }, [bump, controls]);

  return (
    <button
      type="button"
      onClick={openCart}
      aria-label={`Abrir carrinho (${count} ${count === 1 ? "item" : "itens"})`}
      className="relative grid size-11 place-items-center rounded-full border border-line bg-card/70 text-white transition-colors hover:border-primary hover:text-primary"
    >
      <motion.span animate={controls} className="grid place-items-center">
        <ShoppingCart className="size-5" aria-hidden="true" />
      </motion.span>
      {count > 0 && (
        <motion.span
          key={count}
          initial={{ scale: 0.4 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 600, damping: 15 }}
          className="absolute -right-1 -top-1 grid h-5 min-w-5 place-items-center rounded-full bg-primary px-1 text-[11px] font-bold text-night"
          aria-hidden="true"
        >
          {count}
        </motion.span>
      )}
    </button>
  );
};
